import { createAlgoliaFilters, AlgoliaFilterOperator } from '../../../CrossSellProducts/utils/create-algolia-filters.js';
import { queryStringToQueryObject } from '../../utils/query-string.js';

/**
 * Creates a filter string for a given array of sku's.
 */ function createFiltersFromSkus(skus) {
    if (skus.length === 0) {
        return '';
    }
    const filterableSkus = skus.filter(Boolean).map((sku)=>({
            id: 'masterVariant.sku',
            value: sku
        })
    );
    return createAlgoliaFilters(filterableSkus, AlgoliaFilterOperator.OR);
}
/**
 * Returns a filter string based on the query string
 * The queryParameters are extracted and stored in an object containing the parameter and the value(s)
 * This object is matched to the given facets so only the existing facets are used.
 */ function createFiltersFromQuery(query, facets) {
    if (!query || !facets) {
        return '';
    }
    /**
   * Convert the querystring to an object of attributes,
   * These attributes are checked against the configured facets
   * Only existing attributes are returned.
   */ const queryObject = queryStringToQueryObject(query, {
        facets
    });
    /**
   * Iterate over the keys and for each entry create a FilterableAttribute
   */ const filterableAttributes = Object.keys(queryObject).map((filterKey)=>{
        // Find the facet belonging to the filter
        const attribute = facets === null || facets === void 0 ? void 0 : facets.find((facet)=>facet.id === filterKey
        );
        const value = queryObject[filterKey];
        if (!attribute || !attribute.attribute) {
            return null;
        }
        return {
            id: attribute.attribute,
            value
        };
    })// Filter only valid FilterableAttributes
    .filter((val)=>val !== null && Boolean(val.id)
    );
    return createAlgoliaFilters(filterableAttributes, AlgoliaFilterOperator.AND);
}

export { createFiltersFromQuery, createFiltersFromSkus };
//# sourceMappingURL=utils.js.map
